export default __webpack_public_path__ + "static/media/06.14c31ea7.jpg";